import { useLayoutEffect, useRef, useState } from 'react';
export const useIsInCard = () => {
    const conRef = useRef(null);
    const [isInCard, setIsInCard] = useState(undefined);
    useLayoutEffect(() => {
        if (!conRef?.current)
            return;
        const find = (dom) => {
            if (!dom)
                return false;
            if (dom.classList?.contains('cn-ui-m-card'))
                return true;
            return find(dom.parentNode);
        };
        setIsInCard(find(conRef.current));
    }, []);
    return { isInCard, conRef };
};
